import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import PropTypes from 'prop-types';

const bem = new BEMHelper('CollapsableContent');

export default function CollapsableContent({ messages = {}, features: { collapseSizeAndFit: { bypassControls = false } = {} } = {}, children }) {
    return bypassControls ? (
        children
    ) : (
        <div className={bem()}>
            <input type="checkbox" id="collapse" className={bem('collapse')} />
            {messages.viewMore && (
                <label htmlFor="collapse" className="showContent">
                    {messages.viewMore?.()}
                </label>
            )}
            <div className="content">{children}</div>
            {messages.viewLess && (
                <label htmlFor="collapse" className="hideContent">
                    {messages.viewLess?.()}
                </label>
            )}
        </div>
    );
}

CollapsableContent.propTypes = {
    messages: PropTypes.object.isRequired,
    features: PropTypes.isRequired.shape({
        collapseSizeAndFit: PropTypes.isRequired.shape({
            bypassControls: PropTypes.bool.isRequired,
        }),
    }),
    children: PropTypes.array,
};
